import { SiteflowResponse } from "../types/ContentfulTypes";

export const bulkOrderBigQuantity = 999999999;

export const showBulkOrder = (quantities: number[], url?: string) => {
  return url && quantities && quantities.length > 1;
};

export const bulkOrderFlow = (url: string) => {
  return {
    flows: [
      {
        url,
        type: "bulkorder",
      },
    ] as SiteflowResponse[],
  };
};
